import { Col, Container, Jumbotron, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function NoMatch({url}){
    return(
        <Container fluid>
            <Row>
                <Col>
                    <Jumbotron>
                        <div className="text-center">
                            <h1>Oops!. Esta ruta no existe</h1>
                            <Link to={`${url}`}>Regresar el inicio</Link>
                        </div>                        
                    </Jumbotron>
                </Col>
            </Row>
        </Container>
    )
}